import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { undoDeclined, deleteClaim } from "../../action";


export const DeclinedClaimRow = ({
    address,
    description,
    index,
    claimantId,
    claimantName,
    insurer,
    status,
    declinedDate,
    type,
    timestamps
  }) => {

    const [declinedFinalDate, setDeclinedFinalDate] = useState('');
    const dispatch = useDispatch();
    const state = useSelector((state) => state.reducer);
    const [open, setOpen] = useState(false);

    const keys = timestamps ? Object.keys(timestamps).sort((a, b) => new Date(timestamps[a]) - new Date(timestamps[b])) : [];
  const results = keys.map((key) => {
    const currentDate = new Date(timestamps[key]);
    const today = new Date();
    const diffTime = Math.abs(today - currentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { timestamp: key, daysAgo: diffDays };
  });

    useEffect(() => {
        if (declinedDate) {
          const dateObj = new Date(declinedDate);
          const formattedDate = dateObj.toISOString().split('T')[0];
          setDeclinedFinalDate(formattedDate);
        }
      }, [declinedDate]);
    {
      return type === 1 ? (
        <tr key={index} className="border-t">
          <td className="px-6 py-4 text-center">{address}</td>
          <td className="px-6 py-4 text-center">{claimantName}</td>
          <td className="px-6 py-4 text-center">{insurer}</td>
          <td className="px-6 py-4 text-center">{description}</td>
          <td className="px-6 py-4 text-center relative">
            <div
              className="bg-red-50 hover:bg-red-100 px-2 py-1 border border-red-100 rounded-2xl w-max mx-auto text-red-700 cursor-pointer"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              {status}
              {open && (
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white shadow-lg rounded-xl p-4 w-56 z-10 text-sm">
                  {results?.map((item, idx) => (
                    <div key={idx} className="mb-2">
                      <strong>{
                        item.timestamp === "createdAt" ? "Authorized" :   
                        item.timestamp === "assessmentStart" ? "Under Assessment" :
                        item.timestamp === "appealStart" ? "Appeal in Progress" :
                        item.timestamp === "afcaWonDate" ? "Scope of Works" :
                        item.timestamp === "cashSettlementDate" ? "Cash Settlement" :
                        item.timestamp === "eggHatchedDate" ? "Egg Hatched" :
                        item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                        item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                        item.timestamp === "declinedDate" ? "AFCA Claim Denied" : ""
                      }</strong>: {item.daysAgo} day{item.daysAgo !== 1 && 's'}
                    </div>
                ))}
              </div>
              )}
            </div>
          </td>
          <td className="px-6 py-4 text-center"></td>
          <td className="space-x-2 px-6 py-4 text-center">
            {
              state.role !== 0 && (
                <button
                  onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
                  className="relative px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Delete</span>
                </button>
              )
            }
          </td>
          <td className="space-x-2 px-6 py-4 text-center">AFCA Claim Denied date <br /> ({declinedFinalDate})</td>
        </tr>
      ) : (
        <>
          <td className="px-6 py-4 text-center">{address}</td>
          <td className="px-6 py-4 text-center">{claimantName}</td>
          <td className="px-6 py-4 text-center">{insurer}</td>
          <td className="px-6 py-4 text-center">{description}</td>
          <td className="px-6 py-4 text-center">
            <div className="bg-red-50 hover:bg-red-50 px-2 border-red-100 rounded-2xl w-max text-red-700">
              AFCA Claim Denied
            </div>
          </td>
          <td className="px-6 py-4 text-center"></td>
          <td className="space-x-2 px-6 py-4 text-center">
            {
              state.role !== 0 && (
                <button
                  onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
                  className="relative px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Delete</span>
                </button>
              )
            }
          </td>
          <td className="space-x-2 px-6 py-4 text-center border-t">AFCA Claim Denied date <br /> ({declinedFinalDate})</td>
        </>
      )
    }
  };
